import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin, Clock, LifeBuoy } from "lucide-react";
import { SITE, NAV } from "../lib/site";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative border-t border-[#232323] bg-[#050505]"
  >
    <div className="mx-auto max-w-[1400px] px-5 md:px-8 pt-16 md:pt-24 pb-10">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#8a8a8a]">
        Pronto in strada?
      </p>
      <a
        href={`tel:${SITE.phoneTel}`}
        data-testid="footer-headline-call"
        className="mt-4 block font-num uppercase leading-[0.86] tracking-tight text-[10vw] md:text-[9vw] text-[#f4f4f0] transition-colors duration-200 hover:text-[#ff3300]"
      >
        Contattaci
      </a>

      <div className="mt-14 grid grid-cols-1 gap-px border border-[#232323] bg-[#232323] md:grid-cols-4">
        <div
          data-testid="footer-phone"
          className="bg-[#0f0f0f] p-6"
        >
          <Phone size={18} className="text-[#ff3300]" />
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a]">
            Telefono
          </p>
          <a
            href={`tel:${SITE.phoneTel}`}
            className="mt-1 block font-display text-2xl tracking-wide transition-colors duration-150 hover:text-[#ff3300]"
          >
            {SITE.phoneDisplay}
          </a>
          <a
            href={`tel:${SITE.phone2Tel}`}
            className="mt-1 block font-display text-2xl tracking-wide transition-colors duration-150 hover:text-[#ff3300]"
          >
            {SITE.phone2Display}
          </a>
        </div>
        <a
          href={SITE.whatsappMsg}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-whatsapp"
          className="group bg-[#0f0f0f] p-6 transition-colors duration-150 hover:bg-[#1a1a1a]"
        >
          <MessageCircle size={18} className="text-[#25d366]" />
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a]">
            WhatsApp
          </p>
          <p className="mt-1 font-display text-2xl tracking-wide">Scrivici ora</p>
        </a>
        <a
          href={`mailto:${SITE.email}`}
          data-testid="footer-email"
          className="group bg-[#0f0f0f] p-6 transition-colors duration-150 hover:bg-[#1a1a1a]"
        >
          <Mail size={18} className="text-[#ffd600]" />
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a]">
            Email
          </p>
          <p className="mt-1 break-all font-mono text-sm text-[#f4f4f0]">
            {SITE.email}
          </p>
        </a>
        <div className="bg-[#0f0f0f] p-6">
          <MapPin size={18} className="text-[#f4f4f0]" />
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-[#8a8a8a]">
            Zona
          </p>
          <p className="mt-1 font-display text-2xl tracking-wide">{SITE.area}</p>
          <p className="mt-3 flex items-center gap-2 font-mono text-xs text-[#8a8a8a]">
            <Clock size={12} /> {SITE.hours}
          </p>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-6 border-t border-[#232323] pt-8 md:flex-row md:items-center md:justify-between">
        <Link to="/" data-testid="footer-logo" className="inline-block">
          <img
            src="/logo.jpeg"
            alt="Rottamazioni Roma"
            className="h-14 w-auto rounded-md"
          />
        </Link>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="font-mono text-xs uppercase tracking-[0.14em] text-[#8a8a8a] transition-colors duration-150 hover:text-[#f4f4f0]"
            >
              {n.label}
            </Link>
          ))}
          <a
            href={SITE.soccorso}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-soccorso"
            className="flex items-center gap-1.5 font-mono text-xs uppercase tracking-[0.14em] text-[#ff3300] transition-colors duration-150 hover:text-[#f4f4f0]"
          >
            <LifeBuoy size={13} /> Soccorso H24
          </a>
        </nav>
        <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-[#555]">
          © {new Date().getFullYear()} — Ritiro & Demolizione Veicoli
        </p>
      </div>
    </div>
  </footer>
);
